import React, { useEffect, useRef } from 'react';
import { gsap } from '../../lib/gsap';
import { aboutData } from '../../data/aboutData';
import './About.css';

function About() {
  const sectionRef = useRef(null);
  const manifestoRef = useRef(null);
  const statsRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const words = gsap.utils.toArray('.about-word');
      if (words.length) {
        gsap.set(words, { opacity: 0.12 });
        gsap.to(words, {
          opacity: 1,
          stagger: 0.018,
          scrollTrigger: {
            trigger: manifestoRef.current,
            start: 'top 72%',
            end: 'bottom 38%',
            scrub: 1,
          },
        });
      }

      const statEls = gsap.utils.toArray('.about-stat');
      if (statEls.length) {
        gsap.from(statEls, {
          y: 30,
          opacity: 0,
          stagger: 0.12,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: statsRef.current,
            start: 'top 82%',
          },
        });
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const renderWords = (text) =>
    text.split(' ').map((word, i) => (
      <React.Fragment key={i}>
        <span className="about-word">{word}</span>
        {i < text.split(' ').length - 1 && ' '}
      </React.Fragment>
    ));

  return (
    <section className="about-section" id="about" ref={sectionRef}>
      <div className="about-inner">
        <h2 className="section-title about-title">
          {aboutData.title}
        </h2>

        <div className="about-manifesto" ref={manifestoRef}>
          <p className="about-text">
            {renderWords(aboutData.description1)}
          </p>
          <p className="about-text">
            {renderWords(aboutData.description2)}
          </p>
        </div>

        <div className="about-stats" ref={statsRef}>
          <div className="about-stat">
            <span className="stat-number">25%</span>
            <span className="stat-label">frontend performance lift at Fairshare IT Services</span>
          </div>
          <div className="about-stat">
            <span className="stat-number">10+</span>
            <span className="stat-label">reusable UI component modules shipped in production</span>
          </div>
          <div className="about-stat">
            <span className="stat-number">4</span>
            <span className="stat-label">full-stack systems built independently end-to-end</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
